<script>
    import { confirmState, closeConfirm } from "/stores/confirm.js";

    function handleKeydown(e) {
        if (!$confirmState.resolve) return;
        if (e.key === "Enter") {
            e.preventDefault();
            closeConfirm(true);
        } else if (e.key === "Escape") {
            e.preventDefault();
            closeConfirm(false);
        }
    }
</script>

<svelte:window on:keydown={handleKeydown} />

{#if $confirmState.resolve}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div id="confirm-overlay" class="confirm-overlay" role="presentation" on:click|self={() => closeConfirm(false)}>
        <div id="confirm-box" class="confirm-box">
            <div id="confirm-body" class="confirm-body">{$confirmState.message}</div>
            <div class="confirm-footer">
                <button id="btn-cancel" class="buttonB" on:click={() => closeConfirm(false)}>취소</button>
                <button id="btn-confirm" class="buttonA" on:click={() => closeConfirm(true)}>확인</button>
            </div>
        </div>
    </div>
{/if}

<style>
    .confirm-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.4);
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 8vh;
        z-index: 10001;
    }

    .confirm-box {
        background: #fff;
        border-radius: 8px;
        min-width: 300px;
        max-width: 500px;
        max-height: 40vh;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }

    .confirm-body {
        padding: 24px;
        font-size: 14px;
        line-height: 1.6;
        color: var(--gray-800, #333);
        overflow-y: auto;
        white-space: pre-wrap;
        word-break: break-word;
    }

    .confirm-footer {
        padding: 12px 24px;
        display: flex;
        justify-content: flex-end;
        gap: 8px;
        border-top: 1px solid var(--gray-200);
    }
</style>
